export default (selectedPackageId) => ({
    selectedPackageId,
    canContinue: false,

    init () {
        this.$watch('selectedPackageId', () => {
            if (this.selectedPackageId && !this.canContinue) {
                this.canContinue = true;
            }
        });
    },

    flag(item) {
        return !item.is_digital && !item.shipping_price ? 'Free Delivery' : null;
    },

    select(packageId) {
        if (this.selectedPackageId === packageId) {
            this.selectedPackageId = null;
            this.canContinue = false;

            return;
        }

        this.selectedPackageId = packageId;
    }
})
